import React from 'react';
import {toJS} from 'mobx';
import './index.scss';

//other libraries
import { inject, observer } from 'mobx-react';
import Icon from '@mdi/react'
import { mdiClose, mdiCart} from '@mdi/js'
import ImageGallery from 'react-image-gallery';
import ReactHtmlParser from 'react-html-parser';


//api
import {api} from '../../../functions/api';

//material-ui
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

//custom components
import CustomSnackbar from '../../../components/global/snackbar';
import logo from '../../../assets/image/svg/logo.svg';

const TIMEOUT = 3000;

@inject('internal')
@inject('translate')
@observer
export default class ProductDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            count: 1,
            openSnackbar: false,
            message: "",
            loadingBtn: false,
        }
    }

    componentDidMount() {
        this.props.internal.setRoute( this.props.history, this.props.location.pathname)
        this.loadDetail();
        //this.getShoppingCart();
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: "",
                openSnackbar: false
            })
        }, TIMEOUT)
    }

    imagesGallery = []
    loadDetail = async() => {
        this.setState({loading: true})
        let load_data = await api({
            method: 'get',
            url: 'products/' + this.props.match.params.idProduct,
            authorization: this.props.internal.user.access_token,
        })

        if (load_data.success && load_data.success === true) {
            this.props.internal.setDataForSimpeTable(load_data.data.data)
            this.imagesGallery = []
            if(load_data.data.data.asset_image !== null) {
                this.imagesGallery.push(
                    {
                        original: load_data.data.data.asset_image,
                        thumbnail: load_data.data.data.asset_image
                    }
                );
            }
            
            if(load_data.data.data.gallery !== null) {
                for(let i=0; i<(load_data.data.data.gallery).length; i++) {
                    this.imagesGallery.push(
                        {
                            original: load_data.data.data.gallery[i].asset_image,
                            thumbnail: load_data.data.data.gallery[i].asset_image
                        }
                    )
                }
            }

            this.setState({loading: false})
        }

        this.setState({loading: false})

    }

    handleGoBack = () => {
        if(toJS(this.props.internal.backToShoppingCart)) {
            this.props.internal.setBackToShoppingCart(false);
            this.props.internal.setRoute(this.props.history, "/shoppingCart")
            this.props.internal.pushRoute("/shoppingCart")
        }
        else if(toJS(this.props.internal.backToOrderDetail) !== null) {
            // this.props.internal.setRoute(this.props.history, "/"+toJS(this.props.internal.backToOrderDetail))
            this.props.internal.pushRoute(toJS(this.props.internal.backToOrderDetail))
            this.props.internal.setBackToShoppingCart(null);
        }
        else {
            let url = localStorage.getItem('url')
            this.props.internal.setRoute(this.props.history, "/products"+url)
            this.props.internal.pushRoute("/products"+url)
        }
    }

    formatPrice = (data) => {
        const formatter = new Intl.NumberFormat('sk-SK', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2
        })
        return formatter.format(data)
    }

    formatText = (text) => {
        return text;
    }

    handleChangeCount = (event) => {
        this.setState({count: event.target.value})
    }

    getShoppingCart = async() => {
        let load_data = await api({
            method: 'get',
            url: 'shopping-cart',
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.props.internal.addToShoppingCart(load_data.data.data.items);
            this.props.internal.updateNumberOfItemsInShopingCart(load_data.data.data.items_count)
        }
    }

    addToShoppingCart = async() => {
        this.setState({loadingBtn: true})
        let itemId = toJS(this.props.internal.dataForSimpeTable.id)
        let load_data = await api({
            method: 'put',
            url: 'shopping-cart',
            authorization: this.props.internal.user.access_token,
            params: {
                product: Number(itemId),
                quantity: this.state.count
            }
        })

        if(load_data.success === true) {
            this.props.internal.setSnackbar(load_data.data.message, true)
            // this.setState({message: load_data.data.message, openSnackbar: true})
            this.turnOffSnackBar();
            // this.getShoppingCart();
            this.props.internal.addToShoppingCart(load_data.data.data.items);
            this.props.internal.updateNumberOfItemsInShopingCart(load_data.data.data.items_count)
            this.setState({loadingBtn: false})
            this.props.internal.pushRoute("/products")
        }
    }

    render() {
        let status = '';
        if (!this.state.loading) {
            status = toJS(this.props.internal.dataForSimpeTable.warehouse_status_computed)
            if (status) {
                if ('string' === typeof status) {
                    status = status.toUpperCase();
                }
                 status = this.props.translate.i18n.MODULES.PRODUCTS[status] || status
            }
        }
        
        return (
            <div className={'product-detail'}>
            {this.state.loading
                ?
                <CircularProgress className = {'circular-progress'}/>
                :
                <div className={'product-detail-container'}>
                    <div className={'flex space-between header'}>
                        {/* <span className={'title'}>EAN {toJS(this.props.internal.dataForSimpeTable.code)} - {toJS(this.props.internal.dataForSimpeTable.name)}</span> */}
                        <span className={'title'}>EAN {toJS(this.props.internal.dataForSimpeTable.code)}</span>
                        <div className={'close'} onClick={this.handleGoBack}>
                            <Icon path={mdiClose} size={1}/>
                        </div>
                    </div>
                    <div className={'paper-container'}>
                <Paper className={'paper'}>
                    <div className={'container'}>
                <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} />
                    <div className={'flex data'}>
                        {this.imagesGallery.length ?
                            <div className={'images-galery'}>
                                <ImageGallery items={this.imagesGallery} autoPlay={true} showPlayButton={false} showNav={false} showFullscreenButton={false} className={'images-galery'}/>
                            </div>
                            :
                            <div className={'images-galery-empty'}>
                                <img src={logo} alt="raval-trade-logo"/>
                                <span>{this.props.translate.i18n.GLOBAL.ALERTS.IMAGE_GALERY_EMPTY}</span>
                            </div>
                        }
                        <div className={`content ${this.imagesGallery.length ? "" : " w-100"}`}>
                            <h2 className={'title'}>{toJS(this.props.internal.dataForSimpeTable.name)}</h2>
                            <div className={'tags flex'}>
                            {toJS(this.props.internal.dataForSimpeTable.tags).map((tag, index) => {
                                return (
                                    <span key={tag.id} className={'tag'} style={{backgroundColor:tag.color}}>{tag.name}</span>
                                );
                            })}
                            </div>
                            <div className={'category'}>
                                <span>{toJS(this.props.internal.dataForSimpeTable.category) && toJS(this.props.internal.dataForSimpeTable.category.name) ?toJS(this.props.internal.dataForSimpeTable.category.name) : ""}</span>
                            </div>
                            <div className={'ean-warehouse-status flex'}>
                                <div className={'flex titles'}>
                                    <span>{this.props.translate.i18n.MODULES.PRODUCTS.CODE}</span>
                                    <span>{this.props.translate.i18n.MODULES.PRODUCTS.STATUS}</span>
                                </div>
                                <div className={'flex values'}>
                                    <span>{toJS(this.props.internal.dataForSimpeTable.code)}</span>
                                    <span>{status}</span>
                                </div>
                            </div>

                            {/* =========================================== */}
                            {/* klient */}
                            {toJS(this.props.internal.user.data.role.id) === 3 || toJS(this.props.internal.user.data.role.id) === 4 ?
                            <div className={'flex prices'}>
                                <div className={'without-vat'}>
                                    <span className={'text'}>{this.props.translate.i18n.MODULES.PRODUCTS.BUY_PRICE}</span>
                                    <span className={'value'}>{this.formatPrice(toJS(this.props.internal.dataForSimpeTable.client_price))}</span>
                                </div>
                                <div className={'with-vat'}>
                                    <span className={'text'}>{this.props.translate.i18n.MODULES.PRODUCTS.BUY_PRICE_WITH_VAT}</span>
                                    <span className={'value'}>{toJS(this.formatPrice(this.props.internal.dataForSimpeTable.client_price_with_vat))}</span>
                                </div>
                                {toJS(this.props.internal.user.data.client.rabat_level) !== null ?
                                    <div className={'retail'}>
                                        <span className={'text'}>{this.props.translate.i18n.MODULES.PRODUCTS.RECOMMENDED_RETAIL_PRICE}</span>
                                        <span className={'value'}>{toJS(this.formatPrice(this.props.internal.dataForSimpeTable.retail_price_with_vat))}</span>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                            :
                            <div className={'flex prices'}>
                                <div className={'without-vat'}>
                                    <span className={'text'}>{this.props.translate.i18n.MODULES.PRODUCTS.RETAIL_PRICE}</span>
                                    <span className={'value'}>{this.formatPrice(toJS(this.props.internal.dataForSimpeTable.retail_price))}</span>
                                </div>
                                <div className={'with-vat'}>
                                    <span className={'text'}>{this.props.translate.i18n.MODULES.PRODUCTS.RETAIL_PRICE_WITH_VAT}</span>
                                    <span className={'value'}>{toJS(this.formatPrice(this.props.internal.dataForSimpeTable.retail_price_with_vat))}</span>
                                </div>
                                <div className={'retail'}>
                                    <span className={'text'}>{this.props.translate.i18n.MODULES.PRODUCTS.RECOMMENDED_RETAIL_PRICE}</span>
                                    <span className={'value'}>{toJS(this.formatPrice(this.props.internal.dataForSimpeTable.retail_price_with_vat))}</span>
                                </div>
                            </div>
                            }
                            {/* =========================================== */}
                            <div className={'shop flex' + (toJS(this.props.internal.user.data.permissions.shopping_cart) && toJS(this.props.internal.user.data.permissions.shopping_cart.use) && toJS(this.props.internal.dataForSimpeTable.available_to_purchase) ? "" : " hide-shop")}>

                                <div className={'count'}>
                                    <span>{this.props.translate.i18n.MODULES.PRODUCTS.COUNT}: </span>
                                    <TextField
                                        className={'counter-products text-right'}
                                        id="count"
                                        value={this.state.count}
                                        onChange={this.handleChangeCount}
                                        type="number"
                                        disabled={this.props.internal.user.data.permissions.shopping_cart ? false : true}
                                    />
                                </div>
                                {/* <CustomButton
                                    mystyle = {'btn-orange-bg border-radius-18'}
                                    title = {this.props.translate.i18n.GLOBAL.BUTTONS.ADD_TO_CART}
                                    onClick = {this.props.internal.user.data.permissions.shopping_cart ? this.addToShoppingCart : void(0) }
                                >
                                    <Icon path = {mdiCart} size = {1 }/>
                                </CustomButton> */}
                                <Button
                                    className={'btn-orange-bg'}
                                    onClick = {this.props.internal.user.data.permissions.shopping_cart ? this.addToShoppingCart : void(0) }
                                    disabled={this.state.loadingBtn}
                                >
                                    <Icon path = {mdiCart} size = {1 } style={{fill:"white", marginRight: "2px"}}/>
                                    {this.state.loadingBtn ?
                                        <CircularProgress className={'add-to-shopping-cart'}/>
                                        :
                                        this.props.translate.i18n.GLOBAL.BUTTONS.ADD_TO_CART
                                    }
                                </Button>
                            </div>
                            <div className={'description'}>
                                <div>{ReactHtmlParser(this.props.internal.dataForSimpeTable.description) }</div>
                            </div>
                        </div>
                    </div>
                    </div>
                </Paper>
                </div>
                </div>
            }
            
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/products/detail/index.js